import React, { createContext, useContext, useState } from 'react';
import type { Company } from './CompanyContext';
import { logAudit } from './auditLog';

interface ImpersonationContextValue {
  impersonated:      Company | null;
  impersonate:       (company: Company) => void;
  exitImpersonation: () => void;
}

const ImpersonationContext = createContext<ImpersonationContextValue>({
  impersonated:      null,
  impersonate:       () => {},
  exitImpersonation: () => {},
});

export function ImpersonationProvider({ children }: { children: React.ReactNode }) {
  const [impersonated, setImpersonated] = useState<Company | null>(null);
  return (
    <ImpersonationContext.Provider value={{
      impersonated,
      impersonate: (c) => {
        setImpersonated(c);
        logAudit({
          company_id:  c.id,
          action:      'superadmin_impersonation_start',
          entity_type: 'company',
          entity_id:   c.id,
          entity_name: c.name,
          details:     { company_id: c.id, company_name: c.name },
        });
      },
      exitImpersonation: () => {
        const exited = impersonated;
        setImpersonated(null);
        if (exited) {
          logAudit({
            company_id:  exited.id,
            action:      'superadmin_impersonation_end',
            entity_type: 'company',
            entity_id:   exited.id,
            entity_name: exited.name,
            details:     { company_id: exited.id, company_name: exited.name },
          });
        }
      },
    }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export const useImpersonation = () => useContext(ImpersonationContext);
